import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import '~/plugins/vant';
import '~/icons';
import 'vant/lib/index.css';
import '~/router/auth';
import '~/router/page';

import '~/styles/index.less';
import '~/script/rem';
import '~/script/filter';
import '~/script/extensions';
import "~/utils/extensions/index"
import Filters from "./utils/filter";
import { initPCode } from './utils/p-code';

/*
import { Picker } from 'vant';
import { Uploader } from 'vant';
import { NoticeBar } from 'vant';
import { Toast } from 'vant';
import { Empty } from 'vant';
import { Form } from 'vant';
import { Area } from 'vant';
import { Swipe, SwipeItem } from 'vant';
Vue.use(Area);
Vue.use(Form);
Vue.use(Empty);
Vue.use(Toast);
Vue.use(NoticeBar);
Vue.use(Uploader);
Vue.use(Picker);
Vue.use(Swipe);
Vue.use(SwipeItem);
*/
try {
  initPCode();
}
catch (e) {
  console.error(e);
}

Object.keys(Filters).forEach(key => {
  //@ts-ignore
  Vue.filter(key, Filters[key]);  
});


Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
